export const ONE_MB = 1000000;
export const ONE_GB = 1000000000;

export const MP4_FILE_TYPE = 'video/mp4';
export const MOV_FILE_TYPE = 'video/quicktime';
export const WMV_FILE_TYPE = 'video/x-ms-wmv';
export const HEVC_FILE_TYPE = 'image/heic';
